import styled from 'styled-components';
import { animated } from 'react-spring';
import SectionWrapper from 'components/SectionWrapper';

import {
  mediaQueries,
  size,
  InfoBlock as InfoBlockBase,
} from '@everlywell/leaves';

const Section = styled(SectionWrapper)`
  ${mediaQueries.forTabletHorizontalUp} {
    padding-top: ${size.xl1}px;
  }
`;

const InfoBlock = styled(InfoBlockBase).attrs(props => ({
  imageAlt: props.imageAlt,
}))`
  margin-bottom: ${size.xl1}px;
  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: 0;
  }
`;

const AnimatedBlockContainer = styled(animated.div)`
  div[class*='InfoBlock-'] {
    div:first-child {
      background-color: transparent;
    }
  }

  ${mediaQueries.forTabletHorizontalUp} {
    flex: 0 0 33%;
    &:not(:last-child) {
      padding-right: ${size.lg}px;
    }
  }
`;

const InfoBlockContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  ${mediaQueries.forTabletHorizontalUp} {
    flex-direction: row;
  }
  ${AnimatedBlockContainer} {
    &:last-child {
      ${InfoBlock} {
        margin-bottom: 0;
      }
    }
  }
`;

export { Section, InfoBlockContainer, AnimatedBlockContainer, InfoBlock };
